/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pesticide_UsageInputs */

const vi_pesticide_usage = /** @type {(inputs: Pesticide_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công dụng`)
};

/**

* @param {Pesticide_UsageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pesticide_usage = /** @type {((inputs?: Pesticide_UsageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pesticide_UsageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pesticide_usage(inputs)
});